import React from 'react';

import '../About.css';

function About() {
  const stats = [
  { label: "Abu Dhabi", icon: "fas fa-city" },
  { label: "Dubai", icon: "fas fa-building" },
  { label: "Sharjah", icon: "fas fa-mosque" },
  { label: "Ajman", icon: "fas fa-archway" },
  { label: "Umm Al Quwain", icon: "fas fa-anchor" },
  { label: "Ras Al Khaimah", icon: "fas fa-mountain" },
  { label: "Fujairah", icon: "fas fa-water" }
];

  return (
    <div className="about-wrapper">
      {/* 1. Impactful Hero Section */}
      <section className="about-hero-premium">
        <div className="hero-overlay"></div>
        <div className="hero-content-box">
          <span className="subtitle">Premium Care for your Wardrobe</span>
          <h1>Quality You Can Trust,<br/><span>Service You Deserve.</span></h1>
          
          
        </div>
      </section>

      {/* 2. Stats Section */}
      <section className="stats-strip">
  {stats.map((stat, i) => (
    <div className="stat-card" key={i}>
      <div className="stat-icon-small">
        <i className={stat.icon}></i>
      </div>
      <p>{stat.label}</p>
    </div>
  ))}
</section>

      {/* 3. Detailed Story & Mission */}
      <section className="story-section">
  <div className="story-grid">
    <div className="story-image">
      <img src="https://images.unsplash.com/photo-1517677208171-0bc6725a3e60?q=80&w=800" alt="Laundry Expert" />
      <div className="experience-badge">
        <h4>10+</h4>
        <span>Years of Excellence</span>
      </div>
    </div>
    
    <div className="story-text">
      <h2>The Smartest Way <br/>To Care For Your Clothes</h2>
      <p>
        At Mr White Laundry, we believe your time is valuable. For that we created a smart laundry solution powered by technology and convenience.
        <br/>Our platform connects customers with professional laundry services, ensuring:

      </p>
      
      <div className="story-features">
        <div className="feature-tag">
          <i className="fas fa-check-circle"></i> High-quality cleaning
        </div>
        <div className="feature-tag">
          <i className="fas fa-check-circle"></i> Quick turnaround
        </div>
        <div className="feature-tag">
          <i className="fas fa-check-circle"></i> Seamless experience through our mobile app
        </div>
        <div className="feature-tag">
          <i className="fas fa-check-circle"></i> Expert Pressing
        </div>
      </div>
      <p>
        Whether it’s everyday wear or delicate fabrics, we handle everything with care.</p>
    </div>
  </div>
</section>

{/* Process */}

<section className="process-flow-section">
  <div className="section-title-center">
    <span>How We Do It</span>
    <h2>Our Professional Process</h2>
  </div>

  <div className="process-container">
    {/* Step 1 */}
    <div className="process-node">
      <div className="process-img">
        <img src="https://images.unsplash.com/photo-1604328698692-f76ea9498e76?q=80&w=400" alt="Pickup" />
        <div className="step-number">01</div>
      </div>
      <h4>Pickup</h4>
      <p>Convenient doorstep collection at your preferred time.</p>
    </div>

    <div className="process-arrow"><i className="fas fa-chevron-right"></i></div>

    {/* Step 2 */}
    <div className="process-node">
      <div className="process-img">
        <img src="https://images.unsplash.com/photo-1517677208171-0bc6725a3e60?q=80&w=400" alt="Inspection" />
        <div className="step-number">02</div>
      </div>
      <h4>Inspection</h4>
      <p>Detailed checking for stains and fabric material type.</p>
    </div>

    <div className="process-arrow"><i className="fas fa-chevron-right"></i></div>

    {/* Step 3 */}
    <div className="process-node">
      <div className="process-img">
        <img src="https://images.unsplash.com/photo-1545173168-9f1947eebb7f?q=80&w=400" alt="Treatment" />
        <div className="step-number">03</div>
      </div>
      <h4>Treatment</h4>
      <p>Premium washing and eco-friendly dry cleaning.</p>
    </div>

    <div className="process-arrow"><i className="fas fa-chevron-right"></i></div>

    {/* Step 4 */}
    <div className="process-node">
      <div className="process-img">
        <img src="https://images.unsplash.com/photo-1489274495757-95c7c837b101?q=80&w=400" alt="Finishing" />
        <div className="step-number">04</div>
      </div>
      <h4>Finishing</h4>
      <p>Professional steam pressing for a crisp, fresh look.</p>
    </div>

    <div className="process-arrow"><i className="fas fa-chevron-right"></i></div>

    {/* Step 5 */}
    <div className="process-node">
      <div className="process-img">
        <img src="https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?q=80&w=400" alt="Delivery" />
        <div className="step-number">05</div>
      </div>
      <h4>Delivery</h4>
      <p>Freshly cleaned garments delivered back to your door.</p>
    </div>
  </div>
</section>
{/* Mission vision */}

<section className="mission-vision-premium">
  <div className="container-mv">
    
    {/* Left Side: Mission */}
    <div className="mv-card-premium mission">
      <div className="mv-icon">
        <i className="fas fa-bullseye"></i>
      </div>
      <div className="mv-text">
        <span className="mv-tag">The Goal</span>
        <h3>Our Mission</h3>
        <p>
          At Mr White Laundry, our mission is to redefine the laundry experience by 
          blending professional garment care with cutting-edge technology. We aim to 
          provide every household in the UAE with a reliable, high-quality, and 
          eco-friendly service that saves time and adds value to their lifestyle.
        </p>
      </div>
    </div>

    {/* Right Side: Vision */}
    <div className="mv-card-premium vision">
      <div className="mv-icon">
        <i className="fas fa-eye"></i>
      </div>
      <div className="mv-text">
        <span className="mv-tag">The Future</span>
        <h3>Our Vision</h3>
        <p>
          To become the leading digital laundry platform in the Middle East, setting 
          the benchmark for excellence in fabric care, customer convenience, and 
          sustainable operations. We envision a future where laundry is completely 
          hassle-free for everyone.
        </p>
      </div>
    </div>

  </div>
</section>

      {/* 4. Core Values (Graphical Cards) */}
      <section className="values-premium">
  <div className="section-title-center">
    <span>Our Promise</span>
    <h2>Core Values That Drive Us</h2>
  </div>
  
  <div className="values-grid-new">
    {/* Value 1: Expert Care */}
    <div className="val-card">
      <div className="val-img-wrapper">
        <img src="https://images.unsplash.com/photo-1582735689369-4fe89db7114c?q=80&w=500" alt="Expert Care" />
      </div>
      <div className="val-content">
        <div className="icon-bg"><i className="fas fa-star"></i></div>
        <h4>Expert Garment Care</h4>
        <p>At Mr White Laundry, UAE, we provide expert garment care with attention to detail. Our trained specialists handle each item carefully to ensure the best cleaning and finishing results.</p>
      </div>
    </div>

    {/* Value 2: Value for Money */}
    <div className="val-card">
      <div className="val-img-wrapper">
        <img src="https://images.unsplash.com/photo-1554224155-6726b3ff858f?q=80&w=500" alt="Value Pricing" />
      </div>
      <div className="val-content">
        <div className="icon-bg"><i className="fas fa-tags"></i></div>
        <h4>Value-for-Money Pricing</h4>
        <p>We focus on delivering high-quality laundry and dry-cleaning services at budget-friendly prices. Our flexible packages help customers save more while enjoying premium service.</p>
      </div>
    </div>

    {/* Value 3: Eco-Friendly */}
    <div className="val-card">
      <div className="val-img-wrapper">
        <img src="https://images.unsplash.com/photo-1542601906990-b4d3fb778b09?q=80&w=500" alt="Eco Cleaning" />
      </div>
      <div className="val-content">
        <div className="icon-bg"><i className="fas fa-leaf"></i></div>
        <h4>Safe & Green Cleaning</h4>
        <p>We use safe, eco-friendly cleaning solutions that are gentle on your clothes and safe for the environment. Our methods ensure effective cleaning without harmful chemicals.</p>
      </div>
    </div>

    {/* Value 4: In-House QC */}
    <div className="val-card">
      <div className="val-img-wrapper">
        <img src="https://images.unsplash.com/photo-1521791136064-7986c2920216?q=80&w=500" alt="Quality Control" />
      </div>
      <div className="val-content">
        <div className="icon-bg"><i className="fas fa-shield-alt"></i></div>
        <h4>In-House Quality Control</h4>
        <p>All garments are processed in our in-house facility to maintain quality control, faster turnaround, and reliable service. We ensure every item is treated with care and delivered on time.</p>
      </div>
    </div>
    {/* EASY PICKUP & DELIVERY */}
    <div className="val-card">
      <div className="val-img-wrapper">
        <img src="https://plus.unsplash.com/premium_photo-1683134381076-a66aa1c2f06e?q=80&w=871&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" alt="Quality Control" />
      </div>
      <div className="val-content">
        <div className="icon-bg"><i className="fas fa-truck-moving"></i></div>
        <h4>EASY PICKUP & DELIVERY</h4>
        <p>Book your laundry or dry-cleaning service anytime through our app or request a pickup from your location. You can also drop items at your nearest Mr White service point for added convenience.</p>
      </div>
    </div>
  </div>
</section>

      {/* 5. Our Infrastructure & Social Resp */}
      <section className="infra-premium">
        <div className="infra-card">
          <div className="infra-text">
            <h2>Our Infrastructure</h2>
            <p>We use state-of-the-art machinery and automated systems to ensure every fabric is treated with the care it needs.</p>
            <div className="social-tag">
              <i className="fas fa-hand-holding-heart"></i>
              <span>Committed to Eco-Friendly Operations and Social Responsibility.</span>
            </div>
          </div>
          <div className="infra-img">
             <img src="https://images.unsplash.com/photo-1545173168-9f1947eebb7f?q=80&w=800" alt="Machinery" />
          </div>
        </div>
      </section>
    </div>
  );
}

export default About;